import { render, staticRenderFns } from "./BlockInput.vue?vue&type=template&id=92e520f6"
import script from "./BlockInput.vue?vue&type=script&lang=js"
export * from "./BlockInput.vue?vue&type=script&lang=js"
import style0 from "./BlockInput.vue?vue&type=style&index=0&id=92e520f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports